
export const EditOptionModalList = [
    {
        label: "鄉鎮區",
        value: 'district',
        key: "district",
        type: "text",
        placeholder: "請輸入鄉鎮區(大安區...)",
        required: true
    },
    {
        label: "城市",
        value: 'city',
        key: "city",
        type: "text",
        placeholder: "請輸入縣市",
        required: true
    },
    {
        label: "星期",
        value: 'deliveryWeek',
        key: "deliveryWeek",
        type: "number",
        max: 7,
        min: 1,
        placeholder: "請輸入星期",
        required: true,
    },
    {
        label: "說明",
        value: 'description',
        key: "description",
        placeholder: "請輸入說明(周一配送)",
        required: true,
    },
]

export const CreateOptionModalList = [
    {
        label: "鄉鎮區",
        name: "district",
        type: "text",
        placeholder: "請輸入鄉鎮區(大安區...)",
        required: true,
    },
    {
        label: "城市",
        name: "city",
        type: "text",
        placeholder: "請輸入縣市",
        required: true,
    },
    {
        label: "星期",
        name: "deliveryWeek",
        type: "number",
        max: 7,
        min: 1,
        placeholder: "請輸入總距離",
        required: true
    },
    {
        label: "說明",
        name: "description",
        type: "text",
        placeholder: "請輸入說明(周一配送)",
        required: true
    },
]